import * as React from "react";
const SvgFiBrandsBootstrap = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#151A2D" clipPath="url(#fi-brands-bootstrap_svg__a)">
      <path d="M12.973 11.078h-4V7.212h4q1 .001 1.53.43.53.432.529 1.49c0 .629-.196 1.107-.588 1.444-.393.338-.883.502-1.471.502M15.659 14.996c0 .706-.208 1.255-.619 1.639-.408.388-.989.58-1.733.58H8.972v-4.377h4.334c.745 0 1.318.18 1.733.557s.62.907.62 1.6" />
      <path d="M20 0H4C1.8 0 0 1.8 0 4v16c0 2.2 1.8 4 4 4h16c2.2 0 4-1.8 4-4V4c0-2.2-1.8-4-4-4m-2.184 16.851q-.293.717-.922 1.235c-.42.345-.953.62-1.608.824q-.982.306-2.333.306H6.522v-14h6.804q1.883-.001 3.02.863c.757.577 1.137 1.443 1.137 2.608q0 1.059-.518 1.812-.518.755-1.482 1.169v.039q1.295.276 1.961 1.223c.443.635.667 1.427.667 2.384a4 4 0 0 1-.295 1.537" />
    </g>
    <defs>
      <clipPath id="fi-brands-bootstrap_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsBootstrap;
